import React, { Component, Fragment } from 'react';
import ValtixTable from "../../common/Table/Table";
import { getColums } from "./Columns";
import SearchBar from "../../common/SearchBar/Search";
import { PostRequestResolve } from "utils/FetchHelper";
import URL from './../../utils/url';
import CustomButton from "../../common/CustomButton/Button";
import { Message } from "../../variables/general";
import { updateURLParam, getURLParam, deleteURLParam } from "../../utils/Utilities";
import CreateAccount from './CreateAccount';
import { Flex, Modal, Row, Space } from "antd";
import _ from 'lodash';
import ReCAPTCHA from 'react-google-recaptcha';
import GetRequest from '../../utils/FetchHelper';
import { getCurrentPage, getPageSize } from '../../utils/pagination';


class ListAccounts extends Component {

    state = {
        accounts: [],
        selectedAccount: "",
        loading: false,
        editingKey: "",
        selectedRecord: "",
        showCreateModal: false,
        showDeleteModal: false,
        recaptchaResponse: null,
        captchaKey: undefined,
    };

    controller = new window.AbortController()

    recaptcharef = React.createRef();

    constructor(props) {
        super(props);
        updateURLParam('dateCreated', "descend");
    }

    componentDidMount() {
        this.getCaptchaKey();
        this.getAccounts();
    }


    componentWillUnmount() {
        if (this.controller) this.controller.abort();
    }

    toggleLoading = (callback) => {
        this.setState((prevState) => ({
            ...prevState,
            loading: !prevState.loading,
        }), () => {
            typeof callback === "function" && callback();
        });
    }

    getCaptchaKey = () => {
        GetRequest(URL.getCaptchaKey, this.controller.signal)
            .then((resp) => {
                this.setState(prevState => ({
                    ...prevState,
                    captchaKey: _.get(resp, "siteKey", ""),
                }));
            }).catch((err) => {
                Message.error("Getting Captcha Key", err);
            })
    }

    getAccounts = () => {
        this.setState({
            loading: true,
            accounts: [],
        });
        const { filters } = this.state;
        const pageSize = getPageSize();
        const currentPage = getCurrentPage();
        const payload = {
            filters,
            pageInfo: {
                pageSize: pageSize,
                startPageToken: `${(currentPage - 1) * pageSize }`,
            },
        };
        PostRequestResolve(URL.listAccounts, this.controller.signal, payload).then((resp) => {
            const accounts = _.values(_.get(resp, "accounts", {}));
            this.setState({
                loading: false,
                accounts: accounts,
                totalAccounts: _.get(resp, "count", 0),
            });
        }).catch((err) => {
            this.setState({
                loading: false,
            });
            Message.error("List Accounts", err);
        });

    }

    deleteAccount = (callback, errorCallback) => {
        const { selectedRecord, recaptchaResponse } = this.state;
        const payload = {
            name: _.get(selectedRecord, "Name", ""),
            recaptchaResponse,
        };
        if (!payload.name) {
            typeof errorCallback === "function" && errorCallback();
        }
        this.toggleLoading(() => {
            PostRequestResolve(URL.deleteAccount, this.controller.signal, payload).then((resp) => {
                Message.success("Delete Account", "Successfully deleted " + payload.name);
                this.toggleLoading(callback);
            }).catch((err) => {
                this.toggleLoading(errorCallback);
                Message.error("Delete Account", err);
            });
        });

    }


    onFilter = (name, value, callback) => {
        // reset page to 1
        updateURLParam("page", 1);

        this.setState((prevState => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                [name]: value,
            },
        })), () => {
            if (value) updateURLParam(name, value);
            else {
                deleteURLParam(name);
            }
            callback && callback();
            this.getAccounts();
        });
    }

    selectRecord = (record) => {
        this.setState(prevState => ({
            ...prevState,
            selectedRecord: record
        }));
    }

    handleCaptchaChange = (value) => {
        this.setState(prevState => ({
            ...prevState,
            recaptchaResponse: value,
        }));
    }


    openCreateModal = () => {
        this.setState((prevState) => ({
            ...prevState,
            showCreateModal: true,
        }));
    }

    openDeleteModal = () => {
        this.setState((prevState) => ({
            ...prevState,
            showDeleteModal: true,
        }));
    }

    closeCreateModal = (reload) => {
        this.setState((prevState) => ({
            ...prevState,
            showCreateModal: false,
        }), () => {
            if (reload) {
                this.getAccounts();
            }
        });
    }

    closeDeleteModal = (confirm = false) => {
        if (confirm) {
            this.deleteAccount(() => {
                this.setState((prevState) => ({
                    ...prevState,
                    selectedRecord: null,
                    showDeleteModal: false,
                    recaptchaResponse: null,
                }), this.getAccounts);
                this.recaptcharef && this.recaptcharef.current && this.recaptcharef.current.reset();
            })
        } else {
            this.setState((prevState) => ({
                ...prevState,
                showDeleteModal: false,
                recaptchaResponse: null,
            }));
            this.recaptcharef && this.recaptcharef.current && this.recaptcharef.current.reset();
        }
    }

    render() {
        const {
            loading, showCreateModal, selectedRecord, showDeleteModal,
            recaptchaResponse, captchaKey, accounts, totalAccounts,
        } = this.state;

        return (
            <Fragment>
                <Flex style={{ marginBottom: "8px" }} gap={8}>
                    <SearchBar
                        placeholder="Free Search"
                        allowClear
                        width={400}
                        defaultValue={getURLParam("search") || ""}
                        onSearch={(value, callback) => this.onFilter("search", value, callback)}
                    />
                    <SearchBar
                        placeholder="Filter Email"
                        allowClear
                        width={400}
                        defaultValue={getURLParam("email") || ""}
                        onSearch={(value, callback) => this.onFilter("email", value, callback)}
                    />
                    <CustomButton
                        type="primary"
                        onClick={this.getAccounts}    
                        >Refresh
                    </CustomButton>
                </Flex>
                <Row>
                    <Space>
                        <CustomButton
                            type="primary"
                            onClick={this.openCreateModal}
                            enableOnlyForAdmin
                        >Create Account
                        </CustomButton>
                        <CustomButton
                            type="primary"
                            danger
                            onClick={this.openDeleteModal}
                            disabled={!selectedRecord}
                            enableOnlyForAdmin
                        >
                            Delete Account
                        </CustomButton>
                    </Space>
                </Row>
                <ValtixTable
                    name="listAccounts"
                    loading={loading}
                    data={accounts}
                    columns={getColums(!!getURLParam("email"))}
                    onRowSelect={this.selectRecord}
                    enableSingleRowSelection
                    totalRecords={totalAccounts}
                    onPaginationChange={this.getAccounts}
                />
                {showCreateModal && (<CreateAccount onClose={this.closeCreateModal} />)
                }
                <Modal
                    title="Delete Account"
                    open={showDeleteModal}
                    okText="Delete"
                    okButtonProps={{
                        danger: true,
                        disabled: !recaptchaResponse,
                    }}
                    cancelButtonProps={{
                        disabled: loading,
                    }}
                    onOk={() => this.closeDeleteModal(true)}
                    onCancel={() => this.closeDeleteModal(false)}
                    confirmLoading={loading}
                >
                    Are you sure. Do you want to delete <b>{_.get(selectedRecord, "Name", "")}</b>?
                    {(captchaKey) && (
                        <ReCAPTCHA
                            ref={this.recaptcharef}
                            sitekey={captchaKey}
                            onChange={this.handleCaptchaChange}
                        />
                    )}
                </Modal>
            </Fragment>
        );
    }
}

export default ListAccounts;
